import React, { useEffect } from 'react';





import Icon1 from '../assets/img/about/icon1.png';
import Icon2 from '../assets/img/about/icon2.png';
import Icon3 from '../assets/img/about/icon3.png';
import Icon4 from '../assets/img/about/icon4.png';
import Icon11 from '../assets/img/about/icon11.png';
import Icon21 from '../assets/img/about/icon21.png';
import Icon31 from '../assets/img/about/icon31.png';
import Icon41 from '../assets/img/about/icon41.png';

import Start from '../assets/img/about/Star.png';

import Img1 from '../assets/img/cancellation/terms1.png';
import Img2 from '../assets/img/cancellation/terms2.png';
import Img3 from '../assets/img/cancellation/terms3.png';
import Img4 from '../assets/img/cancellation/refund3.png';
import Img5 from '../assets/img/cancellation/terms4.png';
import Img6 from '../assets/img/cancellation/refund2.png';
import Img7 from '../assets/img/cancellation/terms5.png';
import Img8 from '../assets/img/cancellation/terms6.png';
import Img9 from '../assets/img/cancellation/terms7.png';
import Img10 from '../assets/img/cancellation/terms8.png';
import Img11 from '../assets/img/cancellation/terms9.png';
import Img111 from '../assets/img/cancellation/terms11.png';
import Img12 from '../assets/img/cancellation/terms12.png';
import Img14 from '../assets/img/cancellation/privacy8.png';
import Img15 from '../assets/img/cancellation/terms15.png';


import SeoHelmet from "../components/SeoHelmet";

const TermsandConditions = () => {

     useEffect(() => {
    document.body.classList.add('about-page');

    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);

  return (
    <>
     <SeoHelmet />


        <section class="about cancellation">
            <div className='container'>
                <div className='mbrweb_row'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img1} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>Terms and Conditions (Website + Services)</h2> 
                           <p>Welcome to thebhavanasingh.com ("Website"). These Terms and Conditions ("Terms") govern your access to and use of our Website and any services, programs, workshops, courses, consultations, community spaces, digital content, and related offerings (collectively, "Services").</p>                          
                        </div>
                        <div className='warning'>
                                 {/* <div className='mbr-col-sm-6'>
                                    <img src={Img6} />
                                </div> */}
                                <div className='mbr-col-sm-6'>
                                     <p><span className='warn_bold'>By using this Website or purchasing/participating in any Services, you agree to these Terms.</span></p>
                                  
                                </div>
                            </div>
                    </div>
                      
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img2} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>1. About Us</h2> 
                           <p>This Website and Services are operated by:</p> 
                           <p><span>[Insert Legal Entity Name / Brand Owner Name]</span>("we", "us", "our").</p> 
                           <p><span className='privacy_b'>Contact: </span><span>[Insert support email] [Insert phone] [Insert address]</span></p>                         
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img3} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>2. Eligibility</h2> 
                           <p>to use our Services, or have verified consent and supervision from a parent/guardian (where applicable).</p> 
                           <p>You represent that the information you provide is accurate and complete.</p>
                                                  
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img4} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>3. Services and Results Disclaimer</h2> 
                           <p>Our Services relate to personality development, grooming, styling, confidence building, communication, and related areas.</p> 
                           <p><span>Results vary by individual. We do not guarantee specific outcomes.</span></p>
                           <p>Our Services are<span>not medical, psychological, legal, or financial advice</span></p>
                                                  
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img5} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>4. Booking, Payments, and Access</h2> 
                           <p>Prices, inclusions, schedules, and formats are described on the Website or shared by our team.</p>
                           <p>Access to a course/session may be provided via live online link, offline venue details, or member dashboard/community access.</p> 
                           <p>We reserve the right to refuse access if:</p>
                           <ul>
                            <li>payment is incomplete/flagged,</li>
                            <li>you violate conduct rules,</li>
                            <li>we suspect fraud/chargeback abuse.</li>
                            </ul>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img6} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>5. NO REFUNDS (Important)</h2>
                            <div className='warning'>
                                  <div className='mbr-col-sm-6'>
                                    <img src={Img6} />
                                </div> 
                                <div className='mbr-col-sm-6'>
                                     <p><span>Please read our Refund Policy for details (Section 12 references it).</span></p>  
                                </div>
                            </div>
                           <p>If you are unsure before purchase, contact us first.</p>                           
                        </div>
                    </div>
                </div>
                
                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img7} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>6. User Conduct (Code of Respect)</h2> 
                           <p>You agree to:</p> 
                           <ul>
                            <li>behave respectfully toward instructors, staff, and other participants,</li>
                            <li>not harass, abuse, discriminate, threaten, or disrupt sessions,</li>
                            <li>not share private participant information outside the program.</li>
                        
                            </ul>                          
                        </div>
                        <div className='warning'>
                                 <div className='mbr-col-sm-6'>
                                    <img src={Img6} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                     <p><span>We may</span><span className='warn_bold'>remove you from a session/program for misconduct without any refund</span></p>
                                  
                                </div>
                            </div>  
                    </div>
                   
                </div>
                
                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img8} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>7. No Recording Allowed (Strict)</h2> 
                           <p><span>Recording is not permitted in any form </span>, including:</p> 
                           <ul>
                            <li>screen recording,</li>
                            <li>audio recording,</li>
                            <li>video recording,</li>
                             <li>screenshots,</li>
                              <li>photography,</li>
                               <li>saving/downloading session content,</li>
                               <li>or asking someone else to record on your behalf.</li>
                            </ul> 
                            <div className='warning'>
                                 <div className='mbr-col-sm-6'>
                                    <img src={Img6} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                     <p><span className='warn_bold'>If you violate this rule:</span></p>
                                        <ul>
                            <li>you may be removed immediately,</li>
                            <li>your access may be terminated,</li>
                            <li>and you forfeit any fees paid (no refund).</li>
                            </ul> 
                                </div>
                            </div>                          
                        </div>
                    </div>
                </div>

                  <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img9} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>8. Intellectual Property (Our Content)</h2> 
                           <p>All Website content and Service materials—including videos, slides, worksheets, frameworks, methods, and brand assets—are <span>owned by us or licensed to us</span></p>
                           <p>You may not:</p> 
                           <ul>
                            <li>copy, reproduce, sell, distribute, publish, or create derivative works,</li>
                            <li>share course links, downloadable materials, or proprietary methods outside your personal use.</li>
                            </ul>                          
                        </div>
                    </div>
                </div>


                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img10} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>9. Participant Submissions</h2> 
                           <p>If you submit content (messages, images, assignments, feedback, testimonials, etc.):</p> 
                           <ul>
                            <li>you remain the owner of your content,</li>
                            <li>you grant us a limited right to use it to deliver and improve Services. For marketing use (testimonials/before-after), we will <span>seek consent where reasonably required</span></li>
                            </ul>                          
                        </div>
                    </div>
                </div>

                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img11} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>10. Third-Party Tools and Links</h2> 
                           <p>We may use third-party tools (payment gateways, meeting platforms, WhatsApp, email services, analytics). Your use of those tools may be governed by their own terms.</p>                      
                        </div>
                    </div>
                </div>

                 
                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img111} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>11. Changes to Services</h2> 
                           <p>We may modify program structure, schedules, trainers, locations, or tools when required for quality or operational reasons. If we cancel a program entirely, our Cancellation/Refund policies apply.</p>                       
                        </div>
                    </div>
                   
                </div>

                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img12} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>12. Refund and Cancellation Reference</h2> 
                           <p>(published on the Website). These form part of these Terms. <span>Cancellation Policy</span></p>                           
                        </div>
                    </div>
                </div>

                  <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img4 } />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>13. Limitation of Liability</h2> 
                           <p>To the maximum extent permitted by law:</p> 
                           <ul>
                            <li>we are <span>not liable for indirect or consequential damages</span></li>
                            <li>our total liability is <span>limited to the amount you paid</span>for the specific Service giving rise to the claim.</li>
                            </ul>                           
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img14} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>14. Privacy</h2> 
                           <p>Your use is also governed by our <span>Privacy Policy</span></p>                           
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img15} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>15. Governing Law and Disputes</h2> 
                           <p>These Terms are governed by the <span>laws of India</span> . Courts at <span>[New Delhi]</span>will have jurisdiction.</p>                           
                        </div>
                    </div>
                </div>

                <div className='mbr_bottom'>
                    <p>
                       For questions about these Terms, please contact our support team.
                    </p>
                  
                </div>
            </div>
        </section>
       
    </>
  );
}; 

export default TermsandConditions;
